export const BROADCAST_DEVICE_CONFIGURATION = 'BROADCAST'
export const IP_DEVICE_CONFIGURATION = 'IP'
export const DEVICE_CONFIGURATION_TYPES = [
  BROADCAST_DEVICE_CONFIGURATION,
  IP_DEVICE_CONFIGURATION,
]
export const DEFAULT_PRINTER_FILTER_CONFIG = [
  'Microsoft XPS Document Writer',
  'OneNote',
  'Fax',
  'Microsoft Print to PDF',
]
